import i18n from "../../../../i18n/config";
import type { UIMessageType } from "../../../types/UIMessageType";
import type { ComponentMessageType } from "../../../types/ComponentMessageType";
import dayjs from "dayjs";
import flatten from "lodash/flatten";
import groupBy from "lodash/groupBy";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(localizedFormat);

export const formatMessageItems = (messages: ComponentMessageType[]) => {
  const days = groupedDays(messages);
  const messagesGroupByDays = Object.keys(days).reduce<UIMessageType[][]>((acc, date) => {
    const sortedMessages: UIMessageType[] = days[date].map((msg, i, allMeesages) => {
      const messageBefore = allMeesages[i - 1];
      const isSameSender = messageBefore?.senderPhoneNumber === msg.senderPhoneNumber && messageBefore?.senderId === msg.senderId;
      const isSameReceiver = messageBefore?.receiverPhoneNumber === msg.receiverPhoneNumber && messageBefore?.receiverId === msg.receiverId;
      const templateMessageOverwrite = msg.isTemplate
        ? { msg: msg.msg || i18n.t("tuvis_messaging_app.template_sent", msg), senderName: "TUVIS SYSTEM" }
        : {};
      return { ...msg, type: "message", withTail: !messageBefore || !isSameSender || !isSameReceiver, ...templateMessageOverwrite };
    });
    acc.push([{ type: "day", date: dateLabel(date) }, ...sortedMessages]);
    return acc;
  }, []);
  return flatten(messagesGroupByDays);
};

const groupedDays = (messages: ComponentMessageType[]) => {
  return groupBy(messages, (m) => dayjs(m.datetime).format("YYYY-MM-DD"));
};

export const dateLabel = (date: string | number): string => {
  const dateDayjs = dayjs(date);
  const { t } = i18n;
  if (dateDayjs.isToday()) {
    return t("chat_component.today");
  }
  if (dateDayjs.isYesterday()) {
    return t("chat_component.yesterday");
  }
  if (dayjs().isSame(dateDayjs, "week")) {
    return dateDayjs.format("dddd");
  }
  return dateDayjs.format("L");
};
